var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavKeywordLists = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.103 13.589a1 1 0 0 1 0 1.99L8 15.583H1.667a1 1 0 0 1 0-2H8l.103.005Zm4.678-9.827a4.734 4.734 0 0 1 3.978 7.297l2.41 2.41.07.076a1 1 0 0 1-1.408 1.407l-.076-.07-2.41-2.41a4.733 4.733 0 1 1-2.563-8.711Zm0 2a2.734 2.734 0 1 0 0 5.467 2.734 2.734 0 0 0 0-5.467ZM5.103 9.006a1 1 0 0 1 0 1.99L5 11H1.667a1 1 0 0 1 0-2H5l.103.006Zm.595-4.584a1 1 0 0 1 0 1.99l-.102.005H1.667a1 1 0 0 1 0-2h3.929l.102.005Z"
})));
SvgNavKeywordLists.displayName = "SvgNavKeywordLists";
export { SvgNavKeywordLists as ReactComponent };
export default SvgNavKeywordLists;